import { Link } from "react-router-dom";
import { Quote } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS, TESTIMONIALS_SAMPLE } from "@/data/testimonials";

export const Testimonials = () => (
  <section className="relative overflow-hidden bg-[#F3F6F8] grid-light py-20 md:py-28" data-testid="testimonials-section" aria-labelledby="testimonials-heading">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead eyebrow="Client feedback" title={["What surveying teams", "say about the drafting."]} />
        {TESTIMONIALS_SAMPLE && (
          <p className="inline-flex w-fit items-center gap-2 border border-[#D8B66A]/60 bg-[#D8B66A]/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-[#8a6d1f]" data-testid="testimonials-sample-tag">
            Sample feedback — to be replaced with client-approved quotes
          </p>
        )}
      </div>
      <ul className="mt-14 grid gap-px border border-[#102A43]/12 bg-[#102A43]/12 lg:grid-cols-3" data-testid="testimonials-list">
        {TESTIMONIALS.map((t, i) => (
          <Reveal as="li" key={t.name + t.region} delay={i * 0.08} className="group relative flex flex-col bg-white p-8 md:p-10" data-testid={`testimonial-${i + 1}`}>
            <span className="absolute inset-x-0 top-0 h-[2px] origin-left scale-x-0 bg-[#D8B66A] transition-transform duration-500 group-hover:scale-x-100" />
            <div className="flex items-center justify-between">
              <Quote className="h-7 w-7 text-[#D8B66A]" aria-hidden />
              <span className="font-mono text-[10px] tracking-[0.18em] text-[#9fb3c8]">REF {String(i + 1).padStart(2, "0")}</span>
            </div>
            <blockquote className="mt-6 flex-1 font-display text-lg font-semibold leading-snug text-[#102A43] md:text-xl">“{t.quote}”</blockquote>
            <figcaption className="mt-8 border-t border-[#102A43]/10 pt-5">
              <p className="text-sm font-bold text-[#102A43]">{t.name}</p>
              <p className="mt-0.5 text-xs text-[#526579]">{t.org} · {t.region}</p>
              <Link to={`/services/${t.slug}`} className="u-link mt-3 inline-block font-mono text-[10px] uppercase tracking-[0.16em] text-[#1769AA]" data-testid={`testimonial-${i + 1}-service-link`}>{t.service}</Link>
            </figcaption>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
